import axios from 'axios';
const client = "2024klongmang";
const token = encodeURIComponent(window.btoa(client));
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+token.toString()
}

export default axios.create({
  baseURL: `https://lannainfo.library.cmu.ac.th/poempointapi/`,
  // baseURL: `http://localhost/poempoint/api/`,
  headers: headers
});